import React from "react";
import TagsList from "./TagsList";
import { Link } from "gatsby";

export interface TagsViewProps {
  tags: string[];
}

const TagsView = ({ tags }: TagsViewProps) => {
  return (
    <div className="flex flex-col text-sm text-center md:text-left text-lucid-400 mt-10 mb-20">
      <h5 className="h5 pb-1 md:ml-5 font-bold">Find more posts by tags</h5>
      <TagsList tags={tags} />
      <Link to="/blog/tags/"
            className="my-2 pt-2 underline md:text-right md:my-0 md:pt-1 md:mr-5"
      >
        <span>Explore all tags</span>
      </Link>
    </div>
  );
};

export default TagsView;
